/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AdVehicleStreamActiveHubsQueryVariables = Types.Exact<{
  regionId: Types.Scalars['ID']['input']
}>

export type AdVehicleStreamActiveHubsQuery = {
  __typename?: 'Query'
  serviceBreakLocations: {
    __typename?: 'ServiceBreakLocationsResponse'
    serviceBreakLocations: Array<{
      __typename?: 'ServiceBreakLocation'
      id: string
      name: string
    }>
  }
}

export const AdVehicleStreamActiveHubsDocument = gql`
    query AdVehicleStreamActiveHubs($regionId: ID!) {
  serviceBreakLocations(
    input: {regionId: $regionId, filters: {types: [HUB], states: [ACTIVE]}}
  ) {
    serviceBreakLocations {
      id
      name
    }
  }
}
    `

/**
 * __useAdVehicleStreamActiveHubsQuery__
 *
 * To run a query within a React component, call `useAdVehicleStreamActiveHubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamActiveHubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdVehicleStreamActiveHubsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useAdVehicleStreamActiveHubsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdVehicleStreamActiveHubsQuery,
    AdVehicleStreamActiveHubsQueryVariables
  > &
    (
      | { variables: AdVehicleStreamActiveHubsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdVehicleStreamActiveHubsQuery,
    AdVehicleStreamActiveHubsQueryVariables
  >(AdVehicleStreamActiveHubsDocument, options)
}
export function useAdVehicleStreamActiveHubsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdVehicleStreamActiveHubsQuery,
    AdVehicleStreamActiveHubsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdVehicleStreamActiveHubsQuery,
    AdVehicleStreamActiveHubsQueryVariables
  >(AdVehicleStreamActiveHubsDocument, options)
}
// @ts-ignore
export function useAdVehicleStreamActiveHubsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdVehicleStreamActiveHubsQuery,
    AdVehicleStreamActiveHubsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdVehicleStreamActiveHubsQuery,
  AdVehicleStreamActiveHubsQueryVariables
>
export function useAdVehicleStreamActiveHubsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdVehicleStreamActiveHubsQuery,
        AdVehicleStreamActiveHubsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdVehicleStreamActiveHubsQuery | undefined,
  AdVehicleStreamActiveHubsQueryVariables
>
export function useAdVehicleStreamActiveHubsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdVehicleStreamActiveHubsQuery,
        AdVehicleStreamActiveHubsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdVehicleStreamActiveHubsQuery,
    AdVehicleStreamActiveHubsQueryVariables
  >(AdVehicleStreamActiveHubsDocument, options)
}
export type AdVehicleStreamActiveHubsQueryHookResult = ReturnType<
  typeof useAdVehicleStreamActiveHubsQuery
>
export type AdVehicleStreamActiveHubsLazyQueryHookResult = ReturnType<
  typeof useAdVehicleStreamActiveHubsLazyQuery
>
export type AdVehicleStreamActiveHubsSuspenseQueryHookResult = ReturnType<
  typeof useAdVehicleStreamActiveHubsSuspenseQuery
>
export type AdVehicleStreamActiveHubsQueryResult = Apollo.QueryResult<
  AdVehicleStreamActiveHubsQuery,
  AdVehicleStreamActiveHubsQueryVariables
>
